import PropTypes from "prop-types";
import React from "react";
import SimpleBar from "simplebar-react";
import {Link} from "react-router-dom";
import {useOfficeTranslation} from "../../i18n/OfficeTranslation";

const SidebarContent = (props) => {
  const {t} = useOfficeTranslation();
  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{t("common.sidebarContent.menu")}</li>
            <li>
              <Link to="/" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-collection"></i>
                <span key="t-dashboard">{t("common.sidebarContent.dashboard")}</span>
              </Link>          
                <Link to="/accounts" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bxs-business"></i>
                <span key="t-accounts">{t("common.accounts")}</span>
              </Link>
                <Link to="/assets" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-server"></i>
                <span key="t-assets">{t("assets.title")}</span>
              </Link>
                <Link to="/projects" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-briefcase"></i>
                <span key="t-projects">{t("common.projects")}</span>
              </Link>
                <Link to="/persons" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-group"></i>
                <span key="t-persons">{t("common.persons")}</span>
              </Link>
                <Link to="/invoices" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-upload"></i>
                <span key="t-invoices">{t("common.invoices")}</span>
              </Link>
              <Link to="/conversations/inbox" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-conversation"></i>
                <span key="t-emails">{t("common.conversations")}</span>
              </Link>
                 <Link to="/expenses" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-chart"></i>
                <span key="t-expenses">{t("common.expenses")}</span>
              </Link>
              <Link to="/taxes" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-receipt"></i>
                <span key="t-taxes">{t("common.taxes")}</span>
              </Link>
                <Link to="/tenants" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-user-circle"></i>
                <span key="t-tenancies">{t("common.tenants")}</span>
              </Link>
               <Link to="/services" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-server"></i>
                <span key="t-users">{t("common.statusPage")}</span>
              </Link>
               <Link to="/users" onClick={() => document.body.classList.toggle("sidebar-enable")}>
                <i className="bx bx-group"></i>
                <span key="t-users">{t("common.users")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default SidebarContent;
